import vosClient, { IVosResponse } from "../../vosClient";

export interface DepartmentItem {
  Code: string;
  Name_VN: string;
  ParentID: number;
}

export interface EmployeeInfo {
  HR_ID: number;
  HR_No: string;
  Dep_ID: number;
  FullName: string;
  BirthDay: string; // ISO date string
  Email: string;
  DepList: DepartmentItem[];
  Dep_Code: string;
  Dep_Name_VN: string;
  Code_Job_Title: string;
  JobTitle_NameVN: string;
}

export interface IGetDepartmentTreeParams {
  module: string;
}

export interface IDepartmentTree {
  Dep_ID: number;
  ParentID: number;
  Code: string;
  Dep_Name: string;
  Level_1_Code: string;
  Level_1_Name: string;
  Level_2_Code: string;
  Level_2_Name: string;
  Level_3_Code: string;
  Level_3_Name: string;
  Status: string;
  ChildDepartment?: IDepartmentTree[];
}

export class DepartmentService {
  static async getEmployeesByDepartment(departmentId: number) {
    const response = await vosClient.post<IVosResponse<DepartmentItem[]>>(`/Share/Share_Get`, {
      FunctionCode: "HR_DATA_NAMPHUONG_SEARCH",
      ls_Data: `{"Dep_ID":${departmentId},"ViewType" : "NamPhuong","Filter_Optional" : "WORK"}`,
    });

    return response.data;
  }
  static async getDepartmentTree(params: IGetDepartmentTreeParams) {
    const response = await vosClient.get<IVosResponse<IDepartmentTree[]>>(
      "/api/department/code-department-with-permission",
      {
        params,
      },
    );

    return response.data;
  }
}
